<template>
  <el-form
    v-if="this.merchantOptions.length > 0"
    label-width="120px"
    class="select-merchant-top"
  >
    <el-form-item
      class="mb-0"
      :label="$t('merchant')"
    >
      <el-select
        filterable
        v-model="merchantSelected"
        :placeholder="$t('common.selectPlaceholder')"
        popper-class="select-merchant-popper"
        @change="value => changeMerchant(value)"
      >
        <el-option v-for="(item,index) of merchantOptions" :key="index" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'SelectMerchant',
  data() {
    return {
      merchantSelected: '',
      merchantOptions: []
    }
  },
  watch: {
    '$store.state.datasource.merchantNo': {
      handler(newVal) {
        this.init(newVal)
      },
      immediate: true // 是否立即触发
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    getUserData() {
      let userData = {}
      try {
        userData = JSON.parse(localStorage.getItem('userData') || '{}');
      } catch (error) {}
      return userData
    },
    init(merchantNo) {
      const userDataObject = this.getUserData()
      let { merchants, merchantNoSelected } = userDataObject
      if (merchants) {
        this.merchantOptions = []
        this.merchantSelected = ''
        for (const [key, value] of Object.entries(merchants)) {
          this.merchantOptions.push({ label: `${value}@${key}`, value: key })
        }
        this.merchantSelected = merchantNo || merchantNoSelected || ''
      }
    },
    changeMerchant(value) {
      const userDataObject = this.getUserData()
      userDataObject.merchantNoSelected = value
      localStorage.setItem("userData", JSON.stringify(userDataObject));
      const merchants = userDataObject.merchants
      localStorage.setItem("merchantNo", value);
      localStorage.setItem("merchantName", merchants[value]);
      location.reload();
    }
  }
}
</script>

<style lang="scss">
.select-merchant-top {
  margin-top: 12px;
  .el-form-item {
    .el-form-item__label {
      color: #FFFFFF99;
      margin-bottom: 0 !important;
    }
    .el-select {
      width:100%;
      min-width: 350px;
    }
    .el-input {
      input {
        border: 1px solid #c0c0c099;
        background-color: #333333;
        color: #FFFFFF99;
      }
    }
  }
}
.select-merchant-popper {
  background-color: #333333;
  color: #FFFFFF99;
  .el-select-dropdown__item.selected {
    color: #FFFFFF99;
  }
  .el-select-dropdown__item, .el-select-dropdown__item {
    color: #FFFFFF99;
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background-color: #614b4b;
    color: #FFFFFF99;
  }
}
</style>
